import { signInAnonymously } from "firebase/auth";
import { auth } from "./firebase";
import { api } from "./api";
import { track } from "./analytics";

// Flow 0-tap: cliente escanea QR /?join=matchalab → este helper:
//  1) Si ya hay user (anónimo o full) y matchea tenant → no-op.
//  2) Si no hay user → crea sesión anónima (sin UI).
//  3) Asocia el user al tenant via joinTenant callable.
//  4) Fuerza refresh del ID token para que el claim `tenantId` esté disponible.

export type AnonymousJoinResult = {
  ok: boolean;
  tenantId: string;
  wasAnonymous: boolean;
  error?: string;
};

export async function anonymousJoin(tenantId: string): Promise<AnonymousJoinResult> {
  try {
    track("autojoin_started", { tenant_id: tenantId });
    if (!auth.currentUser) {
      await signInAnonymously(auth);
      track("autojoin_anonymous_created", { tenant_id: tenantId });
    }
    const wasAnonymous = auth.currentUser?.isAnonymous ?? false;
    await api.joinTenant({ tenantId });
    if (auth.currentUser) {
      await auth.currentUser.getIdToken(true);
    }
    track("autojoin_completed", { tenant_id: tenantId, was_anonymous: wasAnonymous });
    return { ok: true, tenantId, wasAnonymous };
  } catch (err) {
    const code = (err as { code?: string })?.code ?? "";
    const message = (err as { message?: string })?.message ?? "No pudimos conectarte al comercio.";
    track("autojoin_failed", { tenant_id: tenantId, code });
    return { ok: false, tenantId, wasAnonymous: false, error: code || message };
  }
}
